<template>
  <div class="container">
    <div class="wrapper-card">
      <div class="mwow-detail-header">
        <div class="left">
          <div class="back-btn" @click="$router.go(-1)">
            <i class="el-icon-arrow-left"></i>
            <span>返回</span>
          </div>
        </div>
        <div class="mid">
          <p>班级详情</p>
        </div>
        <div class="right">
          <div
            class="mwow-button success"
            @click="openEditDialog"
            v-if="classData.completion_status == 1"
          >
            编辑
          </div>
          <div
            class="mwow-button info"
            @click="handleDeleteClass"
            v-if="
              classData.completion_status == 2 && classData.class_type === 1
            "
          >
            删除
          </div>
          <div
            class="mwow-button danger"
            @click="handleMultiDelete"
            v-if="
              classData.class_type === 1 && classData.completion_status === 1
            "
          >
            结业
          </div>
        </div>
      </div>
      <div class="detail-wrap">
        <div class="title">
          {{ classData.name
          }}<span class="mwow-tag primary">{{
            classData.course_type === 1 ? "1vN" : "1v1"
          }}</span>
          <span
            class="mwow-button-filled mini lightdanger"
            style="margin-left: 10px"
            v-if="classData.completion_status == 2"
            >已结业</span
          >
          <span class="mwow-tag info" v-if="classData.class_type === 1"
            >正课</span
          >
          <span class="mwow-tag info" v-if="classData.class_type === 2"
            >体验</span
          >
          <span class="mwow-tag info" v-if="classData.class_type === 3"
            >补课</span
          >
        </div>
        <el-row>
          <el-col :span="14">
            <div class="item">
              <span class="label">排课课程:</span>
              <span
                class="tag"
                v-for="item in classData.course_list"
                :key="item.course_id"
                >{{ item.title }}</span
              >
            </div>
            <div class="item">
              <span class="label">授课教师:</span>
              <span
                v-if="
                  !classData.teacher_list || classData.teacher_list.length === 0
                "
                >-</span
              >
              <span
                class="tag"
                v-for="item in classData.teacher_list"
                :key="item.teacher_id"
                >{{ item.name }}</span
              >
            </div>
            <div class="item" v-if="classData.course_type === 1">
              <span class="label">班级人数:</span>
              <span class="text">
                当前{{ classData.current_student_count }}人 | 总{{
                  classData.preset_student_count
                }}人（{{ classData.student_excess === 1 ? "可超" : "不可超" }}）
              </span>
            </div>
            <div class="item" v-if="classData.course_type === 2">
              <span class="label">班级学员:</span>
              <span
                class="text"
                v-if="classData.student && classData.student.name"
              >
                {{ classData.student.name }}
                [ 剩余 {{ Number(studentCourseInfo.usable_number) }}课时
                <span v-if="Number(studentCourseInfo.exceed_number)"
                  >，<span style="color: #f56c6c"
                    >超上
                    {{ Number(studentCourseInfo.exceed_number) }}课时</span
                  ></span
                >
                ]
              </span>
              <span class="text" v-else>-</span>
            </div>
          </el-col>
          <el-col :span="10">
            <div class="item">
              <span class="label">排课课时:</span>
              <span class="text">{{ classData.consume_number }}</span>
            </div>
            <div class="item">
              <span class="label">备注:</span>
              <span class="text">{{ classData.remark || "-" }}</span>
            </div>
            <div class="item">
              <span class="label">上课教室:</span>
              <span class="text">{{
                classData.classroom ? classData.classroom.name : "-"
              }}</span>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="wrapper-card">
      <el-tabs v-model="activeName" @tab-click="handleTabsChange">
        <!-- 为每个 tab-pane 添加 key，避免 vue 报错 -->
        <el-tab-pane
          label="排课课次"
          name="log"
          v-if="classData.completion_status == 1"
          :key="1"
        >
          <tab-log
            v-if="loadedTab.log || activeName === 'log'"
            :classData="classData"
          ></tab-log>
        </el-tab-pane>
        <el-tab-pane
          label="班级学员"
          name="student"
          v-if="
            classData.course_type == 1 &&
            classData.completion_status == 1 &&
            classData.class_type == 1
          "
          :key="2"
        >
          <tab-student
            v-if="loadedTab.student || activeName === 'student'"
          ></tab-student>
        </el-tab-pane>
        <el-tab-pane label="已点名课时" name="signed" :key="3">
          <tab-signed
            v-if="loadedTab.signed || activeName === 'signed'"
          ></tab-signed>
        </el-tab-pane>
        <el-tab-pane
          label="待点名课时"
          name="unsigned"
          v-if="classData && classData.completion_status == 1"
          :key="4"
        >
          <tab-unsigned
            v-if="loadedTab.unsigned || activeName === 'unsigned'"
          ></tab-unsigned>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 抽屉 -->
    <el-drawer
      title="编辑班级"
      :visible.sync="editDialogVisible"
      direction="rtl"
      :size="416"
      destroy-on-close
    >
      <multi-edit-dialog
        :visible.sync="editDialogVisible"
        :originData="classData"
        v-if="classData.course_type === 1"
      ></multi-edit-dialog>
      <single-edit-dialog
        :visible.sync="editDialogVisible"
        :originData="classData"
        v-if="classData.course_type === 2"
      ></single-edit-dialog>
    </el-drawer>
  </div>
</template>
<script>
import tabLog from "./log/index.vue";
import tabStudent from "./student/index.vue";
import tabSigned from "./signed/index.vue";
import tabUnsigned from "./unsigned.vue";
import singleEditDialog from "./singleEditDialog.vue";
import multiEditDialog from "./multiEditDialog.vue";
import { PageModule } from "@/store/module/page";
import {
  getClassDetail,
  deleteClass,
  completionClass,
  getStudentList,
} from "@/api/classManagement";

export default {
  name: "classDetail",
  components: {
    tabLog,
    tabStudent,
    tabSigned,
    tabUnsigned,
    singleEditDialog,
    multiEditDialog,
  },
  data() {
    return {
      activeName: "",
      editDialogVisible: false,
      classData: {},
      loadedTab: {
        log: false,
        student: false,
        signed: false,
        unsigned: false,
      },
      studentCourseInfo: {
        usable_number: "0.00",
        exceed_number: "0.00",
      },
    };
  },

  created() {
    this.init();
  },
  // @Watch("editDialogVisible", { immediate: false, deep: false })
  // onDialogClose(n: boolean) {
  //   if (!n) {
  //     // 弹窗关闭后刷新基础数据
  //     this.init();
  //   }
  // },
  watch: {
    editDialogVisible: {
      handler(n, o) {
        if (!n) {
          // 弹窗关闭后刷新基础数据
          this.init();
        }
      },
      immediate: false,
      deep: false,
    },
  },
  methods: {
    init() {
      const id = this.$route.query.id;
      if (!id) {
        this.$message({
          type: "warning",
          message: "班级不存在",
        });
        return false;
      }
      getClassDetail({ class_id: Number(id) }).then((res) => {
        if (res.error_code === 0) {
          res.data.student = res.data.student || {};
          this.classData = res.data;
          if (res.data.class_type == 2 || res.data.class_type == 3) {
            this.activeName = "log";
            this.loadedTab.log = true;
            return;
          }
          if (res.data.completion_status == 2) {
            this.activeName = "signed";
            this.loadedTab.signed = true;
            return;
          }
          const cache = PageModule.pageInfo.classDetail;
          if (cache.tab) {
            let tab = cache.tab;
            if (cache.tab === "student" && res.data.course_type === 2) {
              tab = "log";
            }
            this.activeName = tab;
            this.loadedTab[tab] = true;
          } else {
            this.activeName = "log";
            this.loadedTab.log = true;
          }
          // 1v1时获取学员剩余课时
          if (res.data.course_type === 2) {
            getStudentList({
              class_id: Number(id),
            }).then((res) => {
              const students = res.data.list;
              if (students[0]) {
                const courses = students[0].course_list;
                if (courses[0]) {
                  this.studentCourseInfo = courses[0].account;
                }
              }
            });
          }
        }
      });
    },
    openEditDialog() {
      this.editDialogVisible = true;
    },
    handleTabsChange(tab) {
      this.loadedTab[tab.name] = true;
      PageModule.SET_PAGE_INFO({
        name: "classDetail",
        key: "tab",
        value: tab.name,
      });
    },
    handleMultiDelete() {
      const arr = [];
      const _t = this;
      arr.push(_t.classData.class_id);
      this.$confirm(
        "结业后，班级内所有学员、未点名课次将被清除， 并且此操作无法恢复。确定要结业？",
        "结业",
        {
          confirmButtonText: "确定",
          confirmButtonClass: "mwow-button-filled success mini",
          cancelButtonText: "取消",
          cancelButtonClass: "mwow-button-filled mini",
          iconClass: "mwow-icon-error",
        }
      )
        .then(() => {
          completionClass({ class_ids: arr }).then((res) => {
            if (res.error_code == 0) {
              this.$message({
                type: "success",
                message: "结业成功!",
              });
              this.init();
            } else {
              this.$message({
                type: "error",
                message: "结业失败!" + res.message,
              });
            }
          });
        })
        .catch(() => {});
    },
    handleDeleteClass() {
      this.$confirm(
        "删除后，学员及排课课时将全部删除，不能恢复。",
        `删除 - ${this.classData.name}`,
        {
          confirmButtonText: "确定",
          confirmButtonClass: "mwow-button-filled success mini",
          cancelButtonText: "取消",
          cancelButtonClass: "mwow-button-filled mini",
          iconClass: "mwow-icon-error",
        }
      )
        .then(() => {
          deleteClass({ class_ids: [this.classData.class_id] }).then((res) => {
            if (res.error_code == 0) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.$router.push({
                name: "classManage",
              });
            } else {
              this.$message({
                type: "error",
                message: "删除失败!" + res.message,
              });
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  background-color: #eef3f6;
  .wrapper-card {
    background-color: #ffffff;
    border-radius: 4px;
    padding: 0 12px 12px 12px;
    margin-bottom: 12px;
  }
}
.detail-wrap {
  .title {
    font-size: 16px;
    line-height: 18px;
    color: #5c5d5e;
    font-weight: bold;
    margin: 22px 0;
    display: flex;
    align-items: center;
    .mwow-tag {
      margin-left: 10px;
    }
  }
  .item {
    line-height: 28px;
    margin-bottom: 14px;
    .label {
      font-size: 14px;
      color: #5c5d5e;
      display: inline-block;
      margin-right: 10px;
      font-weight: bold;
    }
    .tag {
      opacity: 1;
      background: #f6fafc;
      border-radius: 4px;
      padding: 0 15px;
      font-size: 12px;
      color: #5c5d5e;
      margin-right: 10px;
      display: inline-block;
      margin-bottom: 4px;
    }
    .text {
      display: inline-block;
      font-size: 12px;
      color: #5c5d5e;
    }
  }
}
/deep/ .el-tabs__content {
  overflow: visible !important;
}
</style>
